import { FC } from "react";
import { Autocomplete, TextField } from "@mui/material";
import intl from "components/i18n/ReactIntlWrapper";

type RequestSelectProps = {
  requestType?: any;
  selectedRequest?: any;
  handleRequestChange?: any;
  disabled?: boolean | false;
};

const RequestSelect: FC<RequestSelectProps> = ({
  requestType,
  selectedRequest,
  handleRequestChange,
  disabled,
}) => {
  const optionLabel = (option) => (option.groupLabel ? option.groupLabel + " - " + intl.get(option.label) : intl.get(option.label));
  return (
    <Autocomplete
      id="request"
      options={requestType || []}
      getOptionLabel={(option) => optionLabel(option)}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      value={
        requestType != null && selectedRequest != null
          ? requestType.find((req) => Number(req.id) === Number(selectedRequest)) || null
          : null
      }
      onChange={(event, newValue) => handleRequestChange(newValue)}
      loading={requestType == null}
      disabled={disabled}
      clearOnEscape
      sx={{ minWidth: 200 }}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={intl.get("requestSelect.placeholder")}
        />
      )}
    />
  );
};

export default RequestSelect;
